import React from 'react';
import { Container, makeStyles, Typography } from '@material-ui/core';
import Image from 'next/image';

import photo from 'public/images/about-us-photo.png';

const AboutUs: React.FC = (): JSX.Element => {
  const classes = useStyles();

  return (
    <Container>
      <div className={classes.container}>
        <section className={classes.imageSection}>
          <div className={classes.imageContainer}>
            <Image src={photo} />
          </div>
        </section>

        <section className={classes.textSection}>
          <Typography variant="h2" component="h1">
            TOTEMNOTES
          </Typography>
          <Typography variant="h3" component="h2">
            Твоя особлива канцелярія!
          </Typography>

          <Typography variant="h3">ПРИВІТ!</Typography>

          <Typography variant="h5" component="p">
            Я Наталія - графічний дизайнер та засновник бренду креативної канцелярії - Totemnotes.
          </Typography>

          <Typography variant="h5" component="p">
            Працюючи фрілансером, я почала цікавитися плануванням та організацією часу.
          </Typography>

          <Typography variant="h5" component="p">
            Для цього мені був необхідний планер, але асортимент на українському ринку дуже
            засмучував: неякісні матеріали та застарілий дизайн. Саме тоді я вирішила використати
            свої знання з дизайну та друкарських процесів для того, щоб створити власний зручний та
            стильний планер. Так в 2019 році виник бренд під назвою Totemnotes.
          </Typography>

          <Typography variant="h5" component="p">
            На сьогоднішній день в нашому інтернет-магазині представлений великий вибір планерів,
            записників, стікерів, ручок та іншої креативної канцелярії.
          </Typography>

          <Typography variant="h3">Totemnotes - канцелярія, яку ти полюбиш!</Typography>
        </section>
      </div>
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(10)
    }
  },
  imageSection: {
    display: 'flex',
    justifyContent: 'center'
  },
  imageContainer: {
    maxWidth: 361,
    [theme.breakpoints.up('md')]: {
      minWidth: 361
    }
  },
  textSection: {
    '& h2': {
      marginBottom: theme.spacing(5)
    },
    '& h3': {
      marginBottom: theme.spacing(1.5)
    },
    '& p': {
      marginBottom: theme.spacing(1.5)
    }
  }
}));

export default AboutUs;
